export const googleCalendarUrlSE =
  "https://calendar.app.google/YXeR8RT7emMJ315u7";

export const googleCalendarUrlFI =
  "https://calendar.app.google/byKaHxfPaKxEtCdQ7";

// The short links above cannot be framed (X-Frame-Options: SAMEORIGIN), so the
// embed is built from the bare schedule ID they resolve to.
export const googleCalendarEmbedScheduleIdSE =
  "AcZssZ0cfZUL0pGimSuTzJ-E42OGXjM6-RuQN7T28skt9-_vQPXqrBi_Os0HReo7YUMVZXVJTB2CTI_U";

export const googleCalendarEmbedScheduleIdFI =
  "AcZssZ2m_sedfilELtVtRhuWGlm2FbCGW_jylpcWxZwNpRZp49ppeIBzmhpus3vMzKOSxnVj_Bm9m5si";

export const calComLinkSE = "https://cal.com/team/krea/radgivning-advisory";

export const calComLinkFI = "https://cal.com/olli.lappi/debt-advisory";

export const calComLinkDev = "https://cal.com/dev-krea/advisory-meeting";

export {
  calculatorInterestRateValues,
  calculatorRepaymentTimeLeasingValuesMonths,
  calculatorRepaymentTimeValuesMonths,
  requestedLoanAmountValues,
  requestedLoanAmountValuesDefault,
  requestedLoanAmountValuesLarge,
  requestedRealEstateLoanAmountValues,
  requestedRealEstateLoanAmountValuesDefault,
  requestedRealEstateLoanAmountValuesLarge,
} from "./amountValues";
export { GTM_IDS, getGtmId } from "./gtm";
export { type IStaticLinks, LINKS } from "./links";
